// Öffentliche Seite: Lead trägt seine Handynummer für WhatsApp-Updates nach.
// Link kommt aus der Nachfass-Mail: /nummer-nachtragen/{token} (token = Lead-ID)
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL + '/api';
const GOLD = '#EFC24E';

export default function PhoneUpdatePage() {
  const { token } = useParams();
  const [phone, setPhone] = useState('');
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setBusy(true);
    try {
      await axios.post(`${API}/public/phone-update`, { token, phone });
      setDone(true);
    } catch (err) {
      setError(err.response?.data?.detail || 'Fehler — bitte erneut versuchen.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-neutral-950 px-4" data-testid="phone-update-page">
      <div className="w-full max-w-md bg-neutral-900 border border-neutral-800 rounded-2xl p-8 text-center">
        {done ? (
          <div data-testid="phone-update-success">
            <div className="text-4xl mb-3">✅</div>
            <h1 className="text-xl font-bold text-white mb-2">Danke!</h1>
            <p className="text-sm text-neutral-400">
              Deine Nummer ist gespeichert — du erhältst die wichtigsten Updates jetzt auch per WhatsApp.
            </p>
          </div>
        ) : (
          <>
            <div className="text-4xl mb-3">📱</div>
            <h1 className="text-xl font-bold text-white mb-2">WhatsApp-Updates aktivieren</h1>
            <p className="text-sm text-neutral-400 mb-6">
              Trage deine Handynummer ein, damit wir dir News — z.B. zur Eröffnung in
              Rapperswil-Jona — direkt per WhatsApp schicken können.
            </p>
            <form onSubmit={submit} className="space-y-3">
              <input
                type="tel"
                required
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                placeholder="+41 79 123 45 67"
                data-testid="phone-update-input"
                className="w-full rounded-lg bg-neutral-950 border border-neutral-700 text-white placeholder-neutral-500 px-4 py-3 text-sm focus:outline-none focus:ring-2"
                style={{ '--tw-ring-color': GOLD }}
              />
              {error && <p className="text-xs text-red-400" data-testid="phone-update-error">{error}</p>}
              <button
                type="submit"
                disabled={busy}
                data-testid="phone-update-submit"
                className="w-full rounded-lg font-bold py-3 text-sm transition disabled:opacity-60"
                style={{ background: GOLD, color: '#111' }}
              >
                {busy ? 'Speichern…' : 'Nummer speichern'}
              </button>
            </form>
            <p className="text-[10px] text-neutral-500 mt-4">
              Deine Nummer wird nur für StrongFit-Updates verwendet und nicht weitergegeben.
            </p>
          </>
        )}
      </div>
    </div>
  );
}
